module.exports = __webpack_public_path__ + "img/shopx5.4235b921.png";